import Invoice from './container/index';

export default Invoice;



// WEBPACK FOOTER //
// ./src/views/Invoice/index.js